import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { SwiperSlide } from "swiper/react";

import { BaseLink } from "shared/components/common/base-link";
import { fontMerriweather, theme } from "shared/lib/styles";

import { Swiper } from "scmp-app/components/swiper";

import ArrowNext from "./arrow-next.svg";

export const Container = styled.div`
  display: grid;
  grid: "title link" auto "list list" auto / 1fr auto;
  gap: 12px;

  max-inline-size: 1024px;
  margin-inline: auto;
  padding: 20px;

  border-radius: 8px;

  background: rgba(44, 70, 146, 0.1);
`;

export const Title = styled.div`
  grid-area: title;

  color: #2c4692;
  font-weight: 700;
  font-size: 15px;
  font-family: ${fontMerriweather};
  font-style: italic;
  font-variant-numeric: lining-nums proportional-nums;
`;

export const List = styled.div`
  grid-area: list;
`;

export const StyledBaseLink = styled(BaseLink)`
  grid-area: link;

  color: #4585ff;
  font-weight: 700;
  font-size: 14px;
  line-height: normal;
  font-variant-numeric: lining-nums proportional-nums;
  text-decoration-line: underline;
`;

export const StyledSwiperSlide = styled(SwiperSlide)``;

export const StyledSwiper = styled(Swiper)`
  ${StyledSwiperSlide} {
    inline-size: 240px;
  }
`;

export const SwiperWrapper = styled.div`
  position: relative;

  overflow: visible;
  &:hover {
    .other-scmp-swiper-button-prev svg,
    .other-scmp-swiper-button-next svg {
      opacity: 1;
    }
  }

  .other-scmp-swiper-button-prev svg,
  .other-scmp-swiper-button-next svg {
    opacity: 0;

    transition: opacity 1s;
  }

  .other-scmp-swiper-button-disabled {
    opacity: 0;
  }
`;

const ArrowStyle = css`
  inset-block-start: 50%;

  display: none;

  inline-size: 48px;

  ${theme.breakpoints.up("tablet")} {
    position: absolute;
    z-index: 1;

    display: block;

    cursor: pointer;
  }
`;

export const StyledArrowNext = styled(ArrowNext)`
  ${ArrowStyle}
  transform: translateY(-50%);

  ${theme.breakpoints.up("tablet")} {
    inset-inline-end: -20px;
  }
`;

export const StyledArrowPrevious = styled(ArrowNext)`
  ${ArrowStyle}
  transform: translateY(-50%) rotate(180deg);
  ${theme.breakpoints.up("tablet")} {
    inset-inline-start: -20px;
  }
`;
